export default "__VITE_ASSET__ChHbE0KV__"